<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  variant?: string
}>()

const separatorStyleClasses = computed(() => {
  return {
    'flex-1 border-b-[3px] border-b-accent-tertiary': true,
    hidden: ['teaser-group-single-big', 'teaser-group-single-small', 'teaser-group-double-big', 'teaser-group-triple-other', 'teaser-group-quadruple'].includes(props.variant || ''),
    'sm:block': ['teaser-group-triple-other', 'teaser-group-quadruple'].includes(props.variant || '')
  }
})
</script>

<template>
  <div :class="separatorStyleClasses" />
</template>
